// import { Annotorious, ImageAnnotator } from "@annotorious/react";
import { FC, memo, useEffect } from "react";

import { AnnotatePhotoProps } from "./AnnotatePhoto.interface";
// import { Button } from "@/components/atoms";
import { Modal } from "#/molecules";
import { useApi } from "@/api";

const AmnnotatePhoto: FC<AnnotatePhotoProps> = ({
  imageUrl,
  onClose,
  uploadFileId
}) => {

    const { annotation } = useApi();

    const init = () => {
        try {

        const rawImg = document.getElementById("editImg");

        const anno = window.Annotorious.init({
            allowEmpty: true,
            image: rawImg, // image element or ID
        });

        annotation.getAnnotations(uploadFileId).then((response) => {

            const annotations = response.map(r => JSON.parse(r.AnnotationContent));

            anno.setAnnotations(annotations);
            
            anno.on('createAnnotation', function(a) {
                const annoText = JSON.stringify(a);
                annotation.createAnnotation({
                    AnnotationContent: annoText,
                    UploadfileId: uploadFileId
                });
            });

            anno.on('updateAnnotation', function(a, previous) {
                const annoText = JSON.stringify(a);
                annotation.createAnnotation({
                    AnnotationContent: annoText,
                    AnnotationId: previous.id,
                    UploadfileId: uploadFileId,

                });
            });

            anno.on('deleteAnnotation', function(a) {
                annotation.deleteAnnotation(a.id.replace("#", ""));
            });

        });

        // anno.setAnnotations(annotations);

        // anno.on('createAnnotation', function(annotation) {
        //     const annoText = JSON.stringify(annotation);
        //     onAddAnnotation(uploadFileId);
        // });

        // anno.on('updateAnnotation', function(annotation, previous) {
        //     const annoText = JSON.stringify(annotation);
        //     os.updateAnnotation({ UploadfileId: e.UploadFileId, AnnotoriusId: previous.id, AnnotationContent: annoText }).done(function () {})
        // });

        // anno.on('deleteAnnotation', function(annotation) {
        //     os.deleteAnnotation(annotation.id.replace("#", ""));
        // });
        }
        catch {
            console.log('error')
        }
    }

    useEffect(() => {
        init();
    })

    return (
        <Modal onClose={onClose} title="Request Photo Amendment Via Annotation" width="80vw">
        <div
            id="editor"
            style={{ alignItems: 'center', display: 'flex', justifyContent: 'center', width: "100%" }} >
                {/* <Button onClick={init}>Start Annotating</Button> */}
                <img id="editImg" src={imageUrl} style={{ minWidth:'100%'}} width={'100%'}></img>
            {/* <Annotorious>
                <ImageAnnotator>
                    
                </ImageAnnotator>
            </Annotorious> */}
        </div>
        </Modal>
    );
}

export default memo(AmnnotatePhoto)